import React, {FC} from 'react';
import CheckSubscription from "../SubscriptionComment/CheckSubscription/CheckSubscription";
import {SubscriptionSettingsTranslation} from "../interfaces/SubscriptionSettingsTranslation";
import {useLocation} from "react-router-dom";
import SubscriptionHead from "../SubscriptionHead/SubscriptionHead";
import HeaderLogo from "../../../components/HeaderLogo";
import css from "./SubscribeThanks.module.scss";

interface SubscribeThanksProps {
    localization: SubscriptionSettingsTranslation,
    countryCode: string,
}

const SubscribeThanks: FC = () => {
    const {localization, countryCode} = useLocation().state as SubscribeThanksProps;

    if (!localization || !countryCode) {
        return <h1>Loading...</h1>
    }

    return (
        <div className={css.wrapper}>
            <SubscriptionHead title={'Jooble'}/>
            <HeaderLogo className={css.headerLogo}/>
            <CheckSubscription title={localization.ThanksForTheComment} btnName={localization.GoToPersonalCabinet}
                               subTitle={localization.ThanksToYouWeBecomeBetter}
                               link={`https://${countryCode}.jooble.org/employer/employerpage`}/>
        </div>
    );
};

export default SubscribeThanks;

